import { useEffect, useRef } from 'react';

import { selectDocumentUrls, usePDFPreviewStore } from '../store/pdf-preview.store';

export const usePrefetchPDFs = () => {
  const documentUrls = usePDFPreviewStore(selectDocumentUrls);
  const fetchedUrlsRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    documentUrls.forEach((url) => {
      // Only fetch if not already fetched
      if (!fetchedUrlsRef.current.has(url)) {
        fetchedUrlsRef.current.add(url);
        fetch(url)
          .then((res) => res.blob())
          .catch(() => {
            // Remove from set on failure so it can be retried
            fetchedUrlsRef.current.delete(url);
          });
      }
    });
  }, [documentUrls]);
};
